import React, { useState } from "react";
import { Container, Button, Input, Label, Form, FormGroup } from "reactstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import baseUrl from "../../../helpers/baseUrl";
import axios from "axios";

const CouponMain = () => {
  document.title = "Estarch | Create Coupon";

  const [couponName, setCouponName] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [discountRules, setDiscountRules] = useState([
    { minSpend: "", discountAmount: "", discountType: "fixed" },
  ]);
  const [loading, setLoading] = useState(false);

  // Handle discount rule change
  const handleRuleChange = (index, field, value) => {
    const updatedRules = [...discountRules];
    updatedRules[index][field] = value;
    setDiscountRules(updatedRules);
  };

  // Add new discount rule
  const addDiscountRule = () => {
    setDiscountRules([
      ...discountRules,
      { minSpend: "", discountAmount: "", discountType: "fixed" },
    ]);
  };

  // Remove a discount rule
  const removeDiscountRule = (index) => {
    setDiscountRules(discountRules.filter((_, i) => i !== index));
  };

  // Submit Coupon
  const handleSubmit = async (e) => {
    e.preventDefault();
    const couponData = {
      name: couponName,
      startDate,
      endDate,
      discountRules: discountRules.map((rule) => ({
        minSpend: Number(rule.minSpend),
        discountAmount: Number(rule.discountAmount),
        discountType: rule.discountType,
      })),
    };

    try {
      setLoading(true);
      await axios.post(`${baseUrl}/api/coupons/create`, couponData);
      alert("Coupon Created Successfully!");
      setCouponName("");
      setStartDate(new Date());
      setEndDate(new Date());
      setDiscountRules([{ minSpend: "", discountAmount: "", discountType: "fixed" }]);
    } catch (error) {
      alert(error.response?.data?.message || "Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content bg-white">
        <Container fluid>
          <Breadcrumbs title="Estarch" breadcrumbItem="Create Coupon" />
          <div className="shadow-lg p-4 bg-gray-50 rounded-lg">
            <p className="w-full bg-gray-600 text-white p-2 font-bold text-2xl text-center rounded">
              Add Coupon
            </p>

            <Form onSubmit={handleSubmit} className="mt-4 space-y-4">
              {/* Coupon Name */}
              <FormGroup>
                <Label className="font-semibold">Coupon Name</Label>
                <Input
                  type="text"
                  placeholder="Enter coupon name"
                  value={couponName}
                  onChange={(e) => setCouponName(e.target.value)}
                  required
                />
              </FormGroup>

              {/* Start & End Date */}
              <div className="grid grid-cols-2 gap-4">
                <FormGroup>
                  <Label className="font-semibold">Start Date</Label>
                  <DatePicker
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    className="form-control"
                  />
                </FormGroup>
                <FormGroup>
                  <Label className="font-semibold">End Date</Label>
                  <DatePicker
                    selected={endDate}
                    onChange={(date) => setEndDate(date)}
                    className="form-control"
                  />
                </FormGroup>
              </div>

              {/* Discount Rules */}
              <div className="space-y-2">
                <Label className="font-semibold">Discount Rules</Label>
                {discountRules.map((rule, index) => (
                  <div key={index} className="flex gap-2 items-center">
                    <Input
                      type="number"
                      placeholder="Min Spend"
                      value={rule.minSpend}
                      onChange={(e) => handleRuleChange(index, "minSpend", e.target.value)}
                      required
                    />
                    <Input
                      type="number"
                      placeholder="Discount Amount"
                      value={rule.discountAmount}
                      onChange={(e) => handleRuleChange(index, "discountAmount", e.target.value)}
                      required
                    />
                    <Input
                      type="select"
                      value={rule.discountType}
                      onChange={(e) => handleRuleChange(index, "discountType", e.target.value)}
                    >
                      <option value="fixed">Fixed</option>
                      <option value="percentage">Percentage</option>
                    </Input>
                    {index > 0 && (
                      <Button color="danger" onClick={() => removeDiscountRule(index)}>✕</Button>
                    )}
                  </div>
                ))}
                <Button color="primary" outline onClick={addDiscountRule}>
                  + Add Rule
                </Button>
              </div>

              {/* Submit Button */}
              <Button type="submit" color="success" className="w-full mt-3 text-white" disabled={loading}>
                {loading ? "Creating..." : "Create Coupon"}
              </Button>
            </Form>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default CouponMain;
